import { render, staticRenderFns } from "./DelinquentBalanceSummary.vue?vue&type=template&id=95efaee4&"
import script from "./DelinquentBalanceSummary.vue?vue&type=script&lang=js&"
export * from "./DelinquentBalanceSummary.vue?vue&type=script&lang=js&"
import style0 from "./DelinquentBalanceSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports